module.exports = __webpack_public_path__ + "img/man-in-chair.db264cd.svg";